import loadingGif from "../assets/images/loading.gif";

export const Loading = () => {
  return (
    <div className="loading-container">
      <img src={loadingGif} alt="loading" />
    </div>
  );
};
